import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "./assets/scss/tailwind.scss";
import "./assets/css/materialdesignicons.min.css";
import { createPinia } from "pinia";
import { clearAuthCookies } from "@/utils/authSession";
import { clearPendingVerification } from "@/utils/pendingVerification";

const app = createApp(App);

app.use(createPinia());
app.use(router);

app.mount("#app");

function getCookie(name) {
  const match = document.cookie.match(
    new RegExp(`(?:^|; )${name}=([^;]*)`)
  );
  return match ? decodeURIComponent(match[1]) : null;
}

function clearAuthData() {
  clearAuthCookies();
  clearPendingVerification();
}

// Session cookie survives reloads and is shared across tabs,
// but is cleared automatically when the browser fully closes.
const SESSION_COOKIE = "app_session_active";
if (!getCookie(SESSION_COOKIE)) {
  clearAuthData();
  document.cookie = `${SESSION_COOKIE}=1; path=/`;
}